module.exports = __webpack_public_path__ + "img/garantee.1576084.png";